<template>
  <!-- 活动-眉笔活动-推广活动-活动配置弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="推广活动配置"
      width="600px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        size="small"
        :rules="replyRules"
        v-loading="loading"
      >
        <el-form-item>
          <el-switch
            v-model="dataForm.enable"
            :active-value="1"
            :inactive-value="0"
            active-text="打开"
            inactive-text="关闭"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="时间段：">
          <el-date-picker
            style="width: 200px"
            v-model="dataForm.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          ——
          <el-date-picker
            style="width: 200px"
            v-model="dataForm.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'

export default {
  components: {
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//弹窗类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dataForm: {
        enable: 0,//0是关闭 1是开启
        end_time: '',
        start_time: '',
      },
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    getData() {
      this.loading = true
      getApiData('referee_ranking_enable').then((res) => {
        this.dataForm = res
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      patchApiData(`referee_ranking_enable`, params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.closeDialog()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }
}

</script>
<style lang="less" scoped>
</style>